/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_TitleInputs */

const en_us2_plan_title = /** @type {(inputs: Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan`)
};

const pt_br2_plan_title = /** @type {(inputs: Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano`)
};

const es_419_plan_title = /** @type {(inputs: Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan`)
};

const pt_pt2_plan_title = /** @type {(inputs: Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu plano`)
};

const fr_fr2_plan_title = /** @type {(inputs: Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme`)
};

const de_de2_plan_title = /** @type {(inputs: Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan`)
};

const it_it2_plan_title = /** @type {(inputs: Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scheda`)
};

/**
* | output |
* | --- |
* | "Your plan" |
*
* @param {Plan_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_title = /** @type {((inputs?: Plan_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_title(inputs)
	if (locale === "es-419") return es_419_plan_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_title(inputs)
	if (locale === "de-DE") return de_de2_plan_title(inputs)
	if (locale === "it-IT") return it_it2_plan_title(inputs)
	return en_us2_plan_title(inputs)
});
export { plan_title as "plan.title" }